import { render, staticRenderFns } from "./NetaEventDetailsMenuComponent.vue?vue&type=template&id=c6af3060&scoped=true&"
import script from "./NetaEventDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaEventDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaEventDetailsMenuComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaEventDetailsMenuComponent.vue?vue&type=style&index=1&id=c6af3060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6af3060",
  null
  
)

export default component.exports